<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else>
      <vx-card>
        <div>
          <div class="w-full">
            <div
              slot="no-body"
              class="tabs-container inventory_tabSec"
              id="view-customer-tab"
            >
              <div class="mr-2 mb-1 order-1">
                <vs-table
                  :max-items="descriptionItems[0]"
                  pagination
                  :data="teamUsers"
                  description
                  search
                  :description-items="descriptionItems"
                  description-title="Registries"
                  description-connector="of"
                  description-body="Pages"
                  @selected="handleTeamUserSelected"
                >
                  <template slot="header">
                    <div class="mr-2 mb-1 order-1" style="">
                      <vs-button
                        icon-pack="feather"
                        icon="icon-plus"
                        @click="$router.push({ name: 'Create Ticket User' })"
                        size="small"
                        color="primary"
                        >{{ $t("setup.label.CreateTicketTeamUser") }}</vs-button
                      >
                    </div>
                  </template>
                  <template slot="thead">
                    <vs-th>{{ $t("setup.label.Id") }}</vs-th>
                    <vs-th>{{ $t("setup.label.TeamCode") }}</vs-th>
                    <vs-th>{{ $t("setup.label.UserName") }}</vs-th>
                    <vs-th class="tHeadCenter">{{
                      $t("setup.label.Actions")
                    }}</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr
                      :key="index"
                      :data="teamUser"
                      v-for="(teamUser, index) in data"
                    >
                      <vs-td :data="teamUser.id">{{ teamUser.id }}</vs-td>
                      <vs-td :data="teamUser.teamCode">{{
                        teamUser.teamCode
                      }}</vs-td>
                      <vs-td :data="teamUser.username">{{
                        teamUser.username
                      }}</vs-td>

                      <vs-td class="whitespace-no-wrap">
                        <div class="container_img">
                          <feather-icon
                            icon="EyeIcon"
                            title="View"
                            svgClasses="w-5 h-5 stroke-current cursor text-primary"
                            @click.stop="handleTeamUserSelected(teamUser)"
                            class="icon_row"
                          />
                          <feather-icon
                            icon="EditIcon"
                            title="edit"
                            svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                            @click.stop="editTUser(teamUser.teamId)"
                            class="icon_row"
                          />
                          <!-- <feather-icon
                            icon="TrashIcon"
                            title="delete"
                            svgClasses="w-5 h-5 text-danger stroke-current cursor"
                            @click.stop="
                              delId = teamUser.teamId;
                              toggleTeam = false;
                              deleteTicketPopup = true;
                            "
                            class="icon_row"
                          /> -->
                          <feather-icon
                            icon="PlusIcon"
                            title="Add Max Ticket Count"
                            svgClasses="w-5 h-5 stroke-current cursor text-success"
                            class="icon_row"
                            @click.stop.prevent="openMaxTicketPopup(teamUser)"
                          />
                        </div>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
                <div class="centerx">
                  <vs-popup
                    classContent="popup-example"
                    :active.sync="showMaxTicketPopup"
                    title="Max Ticket Count"
                    class="popup-close"
                  >
                    <div class="p-4">
                      <div class="vx-col md:w-1/2 w-full pb-5">
                        <vs-input
                          :label="$t('Max Ticket Count')"
                          class="w-full font-semibold starlabel"
                          v-model="maxActiveTicketCount"
                        />
                      </div>
                      <div class="mt-4 text-center">
                        <vs-button color="warning" type="border" @click="showMaxTicketPopup = false">
                          Cancel
                        </vs-button>
                        <vs-button color="primary" class="ml-2" @click="submitMaxTicketCount">
                          Submit
                        </vs-button>
                      </div>
                    </div>
                  </vs-popup>

                </div>
              </div>
            </div>
          </div>
        </div>
        <delete-popup
          :deletePopup="deleteTicketPopup"
          :title="toggleTeam ? 'Team' : 'Team User'"
          @deletePressed="toggleTeam ? deleteTeam(delId) : deleteTicket(delId)"
          @cancelPressed="deleteTicketPopup = false"
        >
        </delete-popup>
      </vx-card>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";
import DeletePopup from "@/components/DeletePopup.vue";

export default {
  data() {
    return {
      loading: false,
      searchOption: 0,
      toggleTeam: false,
      descriptionItems: [5, 10, 15],
      deleteTicketPopup: false,
      delId: 0,
      activeTab: 0,
      pages1: [
        { name: "Team", active: "active" },
        { name: "Team User", active: "inactive" },
      ],
      showMaxTicketPopup: false,
      maxActiveTicketCount: '',
      selectedTeamUser: null,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
    };
  },
  components: {
    AtomSpinner,
    "delete-popup": DeletePopup,
  },

  computed: {
    ...mapState({
      teamUsers: (state) => state.teams.teamUserList,
    }),
  },
  methods: {
    handleTeamUserSelected(item) {
      this.$router.push({
        name: "View Team User",
        params: { id: item.teamId, name: item.teamCode },
      });
    },

    async getTeamUserList() {
      this.loading = true;
      try {
        this.$store.dispatch("teams/setTeamUserData");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    openMaxTicketPopup(teamUser) {
    this.selectedTeamUser = teamUser;
    this.maxActiveTicketCount = teamUser.maxTicketCount || '';
    this.showMaxTicketPopup = true;
  },

   async submitMaxTicketCount() {
  try {
    await this.$store.dispatch("teams/updateTicketCount", {
      id: this.selectedTeamUser.id,
      maxActiveTicketCount: Number(this.maxActiveTicketCount),
    });

    this.$swal({
      title: "Success",
      icon: "success",
      text: "Max Ticket Count updated successfully!",
    });

    this.showMaxTicketPopup = false;
    this.getTeamUserList();
  } catch (error) {
    const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
  }
},

    editTUser(id) {
      this.$router.push({ name: "Edit Team User", params: { id: id } });
    },

    async deleteTicket(id) {
      try {
        await this.$store.dispatch("teams/deleteTeamUserAction", id);
        this.getTeamUserList();
        this.deleteTicketPopup = false;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },

  mounted() {
    this.getTeamUserList();
  },
};
</script>
<style scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  overflow: hidden;
  background-color: rgba(var(--vs-primary), 1) !important;
  border-radius: 0.2rem;
}

li {
  float: left;
  font-weight: 550;
  font-size: 0.8rem;
  cursor: pointer;
}

li a {
  display: block;
  color: #fff;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  border: solid 0.2rem rgba(var(--vs-primary), 1);
}

li a:hover:not(.active) {
  border: solid 0.2rem rgba(var(--vs-primary), 1) !important ;
  background-color: #fff;
  color: rgba(var(--vs-primary), 1);
  box-shadow: rgba(var(--vs-primary), 1) 0px 7px 29px 0px;
}

.product-order-status.vs-chip-success {
  background: #d5ebdb !important;
  border: 1px solid #34a853;
  color: #34a853 !important;
}
.product-order-status.vs-chip-orange {
  background: #fffae7 !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.view_editTable_btn {
  background: transparent;
  cursor: pointer;
}

.inventory_tabSec >>> .con-vs-tabs .con-ul-tabs {
  width: 40%;
  position: absolute;
  top: 1.3rem;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
</style>
